import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import classes from "./AddPublisherModal.module.css";
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import { useDispatch, useSelector } from 'react-redux';
import { removeToken } from '../store/slices/tokenSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Spinner from './Spinner';
import { addPublisherApi, editPublisherApi } from '../http/http';

const EditPublisherModal = ({ editPublisherModal, setEditPublisherModal, handleServiceClick , serviceDetails }) => {
    const [publisherName, setPublisherName] = useState("");
    const [amount, setAmount] = useState("");
    const [serviceUrl, setServiceUrl] = useState("");
    const [postbackUrl, setPostbackUrl] = useState("");
    const [dailyCap, setDailyCap] = useState("");
    const [skip, setSkip] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { token } = useSelector(state => state?.tokenSlice);

    useEffect(() => {
        if (editPublisherModal) {
            console.log(editPublisherModal?.publisherDetails, 'e')
            setPublisherName(editPublisherModal?.publisherDetails?.pub_name);
            setAmount(editPublisherModal?.publisherDetails?.amount);
            setServiceUrl(editPublisherModal?.publisherDetails?.service_url);
            setPostbackUrl(editPublisherModal?.publisherDetails?.postback_url);
            setDailyCap(editPublisherModal?.publisherDetails?.daily_cap);
            setSkip(editPublisherModal?.publisherDetails?.skip_value);
        }
    }, [editPublisherModal]);

    const editPublisher = async () => {
        try {
            if (publisherName?.trim().length == 0  || amount<0 || amount==null || serviceUrl?.trim().length == 0 || postbackUrl?.trim().length == 0 || dailyCap<0 || dailyCap==null || skip<0  || skip == null) {
                console.log("enter here..");
                return;
            }
            if (!serviceUrl.endsWith("ext_id=<ext_id>")) {
                toast.error("Service Url must include 'ext_id=<ext_id>'")
                return;
            }
            setLoading(true);
            setEditPublisherModal({
                state: false,
                publisherDetails: null
            })
            let data = {
                service_id: serviceDetails?.id,
                pub_ref_id: editPublisherModal?.publisherDetails?.pub_ref_id,
                service_name:serviceDetails?.service_name,
                publisher_name: publisherName, service_url: serviceUrl, postback_url: postbackUrl, daily_cap: dailyCap, amount: amount, skip_value: skip
            }
            await editPublisherApi(data, token);
            await handleServiceClick(serviceDetails);
            setLoading(false);
        } catch (error) {
            console.log(error,'erro');
            setLoading(false);
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    }

    return (
        <Dialog header="Edit Publisher" headerStyle={{ fontFamily: "Ubuntu" }} position='bottom' visible={editPublisherModal?.state} style={{ width: "350px" }} onHide={() => { if (!editPublisherModal?.state) return; setEditPublisherModal({ state: false, publisherDetails: null }); }}>
            <h3 className={classes.publisherDetails}>Service: {editPublisherModal?.publisherDetails?.service_name} ({editPublisherModal?.publisherDetails?.country}, {editPublisherModal?.publisherDetails?.operator})</h3>
            <div className={classes.container}>
                <InputText type="text" value={publisherName} onChange={(e) => setPublisherName(e.target.value)} className={` ${classes.input}`} placeholder="Publisher Name" />
                <InputText type="text" value={amount} onChange={(e) => setAmount(e.target.value)} className={` ${classes.input}`} placeholder="Amount Per Subscription" keyfilter={"int"} maxLength={5} />
                <div className="flex flex-column gap-4">
                    <InputText type="text"
                        value={serviceUrl} onChange={(e) => setServiceUrl(e.target.value)} 
                        invalid={serviceUrl?.length > 0 && !serviceUrl.endsWith("ext_id=<ext_id>")} 
                        className={` ${classes.input}`} placeholder="Service Url" />
                    <small id="username-help">
                        {`Sample: http://optin.telkomsdp.co.za/service/53?cid=700504&ext_id=<ext_id>`}
                    </small>
                </div>
                <div className="flex flex-column gap-4">
                    <InputText type="text" value={postbackUrl}
                        onChange={(e) => setPostbackUrl(e.target.value)} className={` ${classes.input}`} placeholder="Postback Url" />
                    <small id="username-help">
                        {`Sample: https://bmd.go2oh.net/postback?click_id=<ext_id>`}
                    </small>
                </div>
                <InputText type="text" value={dailyCap} onChange={(e) => setDailyCap(e.target.value)} className={` ${classes.input}`} placeholder="Daily Cap" keyfilter={"int"} maxLength={4} />
                <InputText type="text" value={skip} onChange={(e) => setSkip(e.target.value)} className={` ${classes.input}`} placeholder="Skip" keyfilter={"int"} maxLength={3} />
                <div className={classes.center_btn}>
                    <button type='button' className={classes.add_btn} onClick={editPublisher} disabled={loading} >
                        {loading ? "Editing..." : "Edit"}
                    </button>
                </div>
            </div>
        </Dialog>
    )
}

export default EditPublisherModal